import Tariff from './TariffContainer';

export {Tariff};



// WEBPACK FOOTER //
// ./src/modules/home/tariff/index.js